/** In-app "home" (nav, footer, logo when theme uses /). Root "/" stays the marketing landing. */
export const INTERNAL_HOME_PATH = '/';

/**
 * @param {string|null|undefined} logoURL - from theme
 * @returns {string|null} href for logo: empty theme URL keeps "no navigation"; "/" maps to internal home
 */
export function resolveLogoPath(logoURL) {
  if (logoURL === null || logoURL === '') {
    return null;
  }
  if (logoURL === '/') {
    return INTERNAL_HOME_PATH;
  }
  return logoURL;
}
